<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="activatingPopUp = false"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Kategori</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="nama level"
          class="w-full sidebar-input"
          v-model="formData.namaKategori"
          placeholder="Isi dengan nama level"
        />
        <span class="text-danger text-sm">{{
          errors.first("nama level")
        }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl"
          >Cancel</vs-button
        >
        <vs-button
          
          color="success"
          class="ml-2 rounded-2xl"
          
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null }
  },
  data() {
    return {
      formData: {
        namaKategori: ""
      }
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Kategori Penyaluran Dana" : "Tambah Kategori Penyaluran Dana";
    },
    labelButton(){
        return this.passData != null ? "Edit" : "Submit";
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      }
    }
  }
};
</script>
